<template>
  <ion-app>
    <ion-content>
      <ion-grid>
        <div class="banner-message-full p-3">
          <div class="close-banner cursor-pointer" @click="hideNutritionalTable">
            <ion-icon name="close"></ion-icon>
          </div>
          <div class="banner-content-relative pt-3">
            <p class="mb-2 text-lg ion-text-left">Minha dieta</p>
            <p class="mb-2 text-sm grey ion-text-left">
              <span
                class="bold dark"
              >Calculada a partir dos dados informados sobre seu corpo e objetivo.</span> Seus cardápios diários podem diferir desses valores dentro de uma margem calculada pelo algoritmo.
            </p>
            <p class="mb-4 text-sm green ion-text-left">
              Objetivo:
              <span class="bold">{{ goalPT }}</span>
            </p>
            <table class="ion-text-left text-sm">
              <thead class="bg-green white">
                <th class="p-2">Componente</th>
                <th class="p-2">Valor Diário</th>
              </thead>
              <tbody>
                <tr class="border-tr">
                  <td class="p-2 bold">Calorias</td>
                  <td class="p-2 bold">{{target.kcal}}</td>
                </tr>
                <tr>
                  <td class="p-2 bold">Carboidratos totais</td>
                  <td class="p-2 bold">{{target.carbs}}</td>
                </tr>
                <tr>
                  <td class="p-2">Açúcares</td>
                  <td class="p-2">{{target.sugar}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Fibras alimentares</td>
                  <td class="p-2">{{target.fibers}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2 bold">Proteína</td>
                  <td class="p-2 bold">{{target.protein}}</td>
                </tr>
                <tr>
                  <td class="p-2 bold">Gorduras totais</td>
                  <td class="p-2 bold">{{target.fat}}</td>
                </tr>
                <tr>
                  <td class="p-2">Gorduras saturadas</td>
                  <td class="p-2">{{target.saturatedFat}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Gorduras trans</td>
                  <td class="p-2">{{target.transFat}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Vitamina A</td>
                  <td class="p-2">{{target.vitA}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Vitamina C</td>
                  <td class="p-2">{{target.vitC}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Cálcio</td>
                  <td class="p-2">{{target.calcium}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Ferro</td>
                  <td class="p-2">{{target.iron}}</td>
                </tr>
              </tbody>
            </table>
            <p
              class="mt-3 text-xs grey ion-text-left"
            >Cáculos baseados na fórmula de Harris-Benedict e nas diretrizes da OMS</p>
          </div>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// store
import store from "../../utils/store.js";
// component
export default {
  name: "MyDiet",
  data() {
    return {
      user: store.state.user,
      profile: store.state.profile,
      goalPT: "",
      target: {
        kcal: 0,
        fat: 0,
        saturatedFat: 0,
        transFat: 0,
        cholesterol: 0,
        sodium: 0,
        carbs: 0,
        fibers: 0,
        sugar: 0,
        protein: 0,
        vitA: 0,
        vitC: 0,
        calcium: 0,
        iron: 0
      }
    };
  },
  methods: {
    showNutritionalTable() {
      this.banner = {
        class: "banner-message-full p-3"
      };
    },
    hideNutritionalTable() {
      this.$router.go(-1);
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      if (instance.profile.data.goal) {
        if (instance.profile.data.goal === "loseWeight") {
          instance.goalPT = "Emagrecimento";
        } else if (instance.profile.data.goal === "gainMuscles") {
          instance.goalPT = "Hipertrofia";
        } else if (instance.profile.data.goal === "stayHealthy") {
          instance.goalPT = "Equilíbrio";
        } else {
          //
        }
      }
      instance.target = {
        kcal: `${Math.round(instance.profile.data.target.kcal)} kcal`,
        fat: `${Math.round(instance.profile.data.target.fat / 1000)} g`,
        saturatedFat: `${Math.round(
          instance.profile.data.target.saturatedFat / 1000
        )} g`,
        transFat: `-`,
        cholesterol: `${Math.round(
          instance.profile.data.target.cholesterol
        )} mg`,
        sodium: `${Math.round(instance.profile.data.target.sodium / 1000)} mg`,
        carbs: `${Math.round(instance.profile.data.target.carbs / 1000)} g`,
        fibers: `${Math.round(instance.profile.data.target.fibers / 1000)} g`,
        sugar: `${Math.round(instance.profile.data.target.sugar / 1000)} g`,
        protein: `${Math.round(instance.profile.data.target.protein / 1000)} g`,
        vitA: `${Math.round(instance.profile.data.target.vitA)} ng`,
        vitC: `${Math.round(instance.profile.data.target.vitC)} mg`,
        calcium: `${Math.round(instance.profile.data.target.calcium)} mg`,
        iron: `${Math.round(instance.profile.data.target.iron / 1000)} mg`
      };
    } catch (e) {
      console.log(e);
    }
  }
};
</script>

<style scoped>
.banner-message-full {
  overflow-y: scroll;
  background: #f7f7f7;
  box-shadow: 0 -12px -6px 3px rgba(0, 0, 0, 0.15);
}

.close-banner {
  position: fixed;
  top: 50px;
  right: 20px;
  z-index: 1001;
  font-size: 2rem;
}

.banner-content-relative table {
  width: 100%;
  overflow: none;
}

.border-tr {
  border-bottom: 1px solid lightgrey;
}
</style>